import React from 'react';
import Signup from '../../Components/Signup/Signup'
import './signup.css'

const Signuppage = () => {
    return (
        <>
            <Signup />
        </>
    );
}

export default Signuppage;